import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Spin,
} from 'antd';
import {
  PlusCircleOutlined,
} from '@ant-design/icons';
import Table from 'components/Table';

const TableAddConsiderado = ({
  permission,
  get,
  columns,
  callback,
  propName,
  ciudadano,
  filterProp,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ results: [], count: 0 });
  const [currentPage, setCurrentPage] = useState(1);

  const fetchData = async (page = 1, q = null) => {
    setLoading(true);
    setCurrentPage(page);
    const res = await get({ page, ...q, [filterProp]: ciudadano });
    setData(res);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const _data = await get({ page: 1, [filterProp]: ciudadano });
      if (mounted) {
        setData(_data);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const handleOnRowClick = (record) => {
    if (selectedRowKeys.includes(record.id)) {
      const clone = [...selectedRowKeys];
      clone.splice(selectedRowKeys.indexOf(record.id), 1);
      setSelectedRowKeys(clone);
    } else {
      setSelectedRowKeys([...selectedRowKeys, record.id]);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'checkbox',
    onChange: (keys) => setSelectedRowKeys(keys),
  };

  return (
    <Spin
      tip="Cargando..."
      spinning={loading}
    >
      <Table
        cols={columns}
        data={data?.results || []}
        rowSelection={rowSelection}
        handleOnRowClick={handleOnRowClick}
        customActions={[{
          icon: <PlusCircleOutlined />,
          text: 'Vincular al Ciudadano',
          onClick: () => {
            callback({ [propName]: selectedRowKeys });
          },
        }]}
        rowKey="id"
        allowImport
        permission={permission}
        hasAllViewPermission
        pagination={false}
        count={data.count}
        allowSort={false}
        paginationCallback={fetchData}
        currentPage={currentPage}
      />
    </Spin>
  );
};

TableAddConsiderado.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.exact({
    view: PropTypes.bool,
    add: PropTypes.bool,
    change: PropTypes.bool,
    delete: PropTypes.bool,
    authorize: PropTypes.bool,
    cancel: PropTypes.bool,
    export: PropTypes.bool,
    import: PropTypes.bool,
    sync: PropTypes.bool,
    model: PropTypes.string,
    hasAllViewPermission: PropTypes.bool,
  })).isRequired,
  permission: PropTypes.exact({}).isRequired,
  get: PropTypes.func.isRequired,
  propName: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired,
  ciudadano: PropTypes.number,
  filterProp: PropTypes.string,
};

TableAddConsiderado.defaultProps = {
  ciudadano: 0,
  filterProp: 'empresa__ciudadano',
};

export default TableAddConsiderado;
